import { Typography } from '@weareopenr/component-library';
import CollapsibleSection from 'src/components/CollapsibleSection';
import { getVenuesWithChannels } from '../../utilities/getVenuesWithChannels/getVenuesWithChannels';
import { IPublishDestination } from '../../types';
import styles from '../SummaryView.module.scss';

interface IVenuesSummarySectionProps {
  number: string;
  publicationData: IPublishDestination[];
  selectedChannelIds: string[];
  selectedVenueIds: string[];
}

const VenuesSummarySection = ({
  number,
  publicationData,
  selectedChannelIds,
  selectedVenueIds,
}: IVenuesSummarySectionProps) => {
  const selectedVenues = getVenuesWithChannels(publicationData, selectedChannelIds, selectedVenueIds);
  const numberOfVenues = selectedVenues.length;

  return (
    <CollapsibleSection
      number={number}
      title="Venues"
      subtitle={`${numberOfVenues} ${numberOfVenues === 1 ? 'venue' : 'venues'} selected`}
    >
      <div className={styles['channel-container']}>
        <div className={styles['venue-container']}>
          {selectedVenues.map(({ venue, channelNames }) => (
            <div key={venue.venue_id} data-testid={`summary-venue-${venue.venue_id}`}>
              <Typography weight="semi-bold">{venue.name}</Typography>
              <Typography size="small" className={styles['muted']}>
                {channelNames.join(', ')}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default VenuesSummarySection;
